<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-09-29 16:23:11
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-10 10:37:15
-->
<template>
  <div>
      <div class="header" :style="{minWidth:isCollapse || isHome?'1276px':'1436px'}">
    <div class="left">
      <div class="icon-fater">
        <!-- <img @click="close" class="close-img" src="@/assets/images/close.png" /> -->
        <i @click="close" class="ri-menu-2-fill icon-left"></i>
      </div>
      <div class="dir"></div>
      <div class="title">甘孜州综合信息管理平台</div>
    </div>
    <div class="right">
      <!-- <img class="img" src="@/assets/images/mac.png" /> -->
      <div @click="toUrl" class="wang-zhan">
           <i   class="ri-mac-fill icon-zhan"></i>
           <div class="text-zhan">网站</div>
      </div>
      <a-dropdown>
        <div class="select-title">
          <i class="ri-account-pin-box-fill down-icon"></i>
          <span class="text">{{ selectJoin }}</span>
          <i class="ri-arrow-down-s-fill down-icon"></i>
        </div>
        <a-menu slot="overlay">
          <a-menu-item v-if="item.title != selectJoin" v-for="(item,index) in siteData" :key="index" @click="change(item)">
            <span>{{item.name}}</span>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
       <div @click="shouche" style="margin-left:20px" class="wang-zhan">
           <i   class="ri-file-text-fill icon-zhan"></i>
           <div class="text-zhan">手册</div>
      </div>
      <!-- <img class="img" src="@/assets/images/text.jpg" />
      <img class="img" src="@/assets/images/news.jpg" />
      <img class="img" src="@/assets/images/peple.jpg" /> -->
      <span class="user-box">
          <a-dropdown>
            <div class="select-title">
               <i class="ri-admin-fill name-icon"></i>
              <span class="text">{{name}}</span> 
              <i class="ri-arrow-down-s-fill down-icon"></i>
            </div>
            <a-menu slot="overlay">
              <a-menu-item @click="eidtPassword">
                <span>修改密码</span>
              </a-menu-item>
              <a-menu-item @click="lognOut">
                <span>退出登录</span>
              </a-menu-item>
            </a-menu>
        </a-dropdown>
      </span>
    </div>
  </div>
  <el-dialog
      :title="'修改密码'"
      :visible.sync="dialogVisible"
      width="535px"
      top="17%"
       class="demo-ruleForm"
      :show-close="flagLogin != 0?true:false"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
      >
      <div class="title-box">
            <i class="el-icon-info icon-title"></i>
            <div>初次登录平台，请修改密码，并牢记密码</div>
          </div>
       <el-form-item label="原密码" prop="oldPassword">
          <el-input
            v-model="ruleForm.oldPassword"
            placeholder="请输入原密码"
          >
            <i class="ri-eye-fill" slot="suffix"></i>
          </el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="ruleForm.newPassword"
            maxlength="15"
            placeholder="新密码不少于12位最多15位，应包含字母、数字及符号 ~!@#$%^&* "
          >
           <i class="ri-eye-fill" slot="suffix"></i>
          </el-input>
        </el-form-item>
       <el-form-item label="确认密码" prop="quePassword">
          <el-input
           maxlength="15"
            v-model="ruleForm.quePassword"
            placeholder="请再次输入新密码"
          >
           <i class="ri-eye-fill" slot="suffix"></i>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" v-if="flagLogin != 0" @click="cancellation">取 消</el-button>
        <el-button size="medium" v-repeatClick :loading="loadingBtn" type="primary" @click="addLinksFn">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {list,loginOut,updatePassword} from '@/api/common.js';
import router from "../../router";
import { removeWatermark } from "@/utils/waterMark";
import { message } from 'ant-design-vue';
import {pass} from '@/utils/reg.js';
export default {
  data() {
    return {
      selectJoin: "",
      toWangZhan:"",
      siteData:[],
      flagLogin:1,
      name:"",
      dialogVisible:false,
      loadingBtn:false,
      ruleForm:{
        oldPassword:"",
        newPassword:"",
        quePassword:"",
      },
      rules: {
        oldPassword: [
          { required: true, message: "请输入原密码", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            validator: pass,trigger: "blur",
          } 
        ],
        quePassword: [{ required: true, message: "请输入确认密码", trigger: "blur" }],
      },
    };
  },
  props: ["isCollapse","isHome"],
  mounted(){
    this.getListSite();
    this.name = JSON.parse(sessionStorage.getItem('userInfo')).name;
    this.flagLogin = sessionStorage.getItem('flagLogin');
    if(this.flagLogin == 0){
        this.dialogVisible = true;
    }
  },
  methods: {
    toUrl(){
        window.open(this.toWangZhan)
    },
    cancellation(){
        this.$refs.ruleForm.resetFields();
        this.dialogVisible = false;
    },
    shouche(){
      window.open('https://files.gzz.gov.cn/upload/fujian/file/2023/5/fujian_2023051512180990.pdf')
    },
    addLinksFn(){
        let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        this.loadingBtn = true;
         this.$refs.ruleForm.validate((valid) => {
            if(valid){
              if(this.ruleForm.newPassword != this.ruleForm.quePassword){
                    message.error('新密码与确认密码不一致');
                    this.loadingBtn = false;
                    return;
                }else{
                    updatePassword({...this.ruleForm,id:userInfo.id}).then((res)=>{
                        if(res.code == 0){
                            this.$refs.ruleForm.resetFields();
                            this.dialogVisible = false;
                            this.lognOut()
                        }
                         this.loadingBtn = false;
                    })
                }
            }else{
              this.loadingBtn = false;
            }
         })
        
    },
    eidtPassword(){
       this.dialogVisible = true;
    },
    handleClose(){
      if(this.flagLogin != 0){
        this.$refs.ruleForm.resetFields();
         this.dialogVisible = false;
      }
    },
    getListSite(){
      let userInfo=  JSON.parse(sessionStorage.getItem('userInfo'));
      list({
        manId:userInfo.id,
        organizationIds:userInfo.organizationId,
        superManagement:userInfo.superManagement,
      }).then((res)=>{
        if(res.code == 0){
            this.selectJoin = sessionStorage.getItem('siteName') ||  res.data[0].name;
            this.toWangZhan = sessionStorage.getItem('toWangZhan') ||  res.data[0].domain;
            this.siteData = JSON.parse(JSON.stringify(res.data));
            if(!sessionStorage.getItem('siteId')){
                this.change(res.data[0]);
            }
        }
      })
    },
    close() {
      this.$emit("clickClose");
    },
    change(item){
      this.selectJoin = item.name;
      this.toWangZhan = `http://${item.domain}`
      sessionStorage.setItem('siteName',item.name);
      sessionStorage.setItem('toWangZhan',`http://${item.domain}`);
      localStorage.removeItem('column_man_id');
      localStorage.removeItem('column_man_name');
      localStorage.removeItem('columnOpenIds')
      this.$emit('change',item)
    },
    lognOut(){
        loginOut({
          id:JSON.parse(sessionStorage.getItem('userInfo')).id,
        }).then((res)=>{
            if(res.code == 0){
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('userInfo');
                sessionStorage.removeItem('menuData');
                sessionStorage.removeItem('siteId');
                sessionStorage.removeItem('siteName');
                removeWatermark();
                router.push("/login");
            }
        })
    }
  },
};
</script>
<style scoped lang="less">
.header {
  height: 60px;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: space-between;
  z-index: 1;
  box-shadow: 0 -1px 9px 0 rgba(0, 0, 0, 0.6);
  background-color: rgba(60, 66, 77, 1);
  text-align: center;
  border: 1px solid rgba(78, 86, 102, 1);
  min-width: 1200px;
  .right {
    display: flex;
    .img {
      margin-left: 30px;
    }
    .name {
      margin-left: 6px;
      //font-weight: 600;
    }
    .img-two {
      margin-right: 24px;
    }
  }
  .left {
    display: flex;
    align-items: center;
    height: 100%;
    .title {
      font-size: 18px;
      margin-left: 24px;
      color: rgba(255, 255, 255, 1);
      font-size: 18px;
      text-align: left;
      font-family: Roboto-bold;
    }
    .dir {
      width: 1px;
      height: 24px;
      line-height: 20px;
      background-color: rgba(78, 86, 102, 1);
      text-align: center;
    }
    .icon-fater {
      width:76px;
      text-align: center;
      .close-img {
        width: 16px;
        height: 16px;
        margin-top: -6px;
        cursor: pointer;
      }
    }
  }
}
.select-title{
  display: flex;
  align-items: center;
  line-height: 20px;
  border-radius: 8px;
  background-color: rgba(78, 86, 102, 1);
  padding: 6px;
  margin-left: 20px;
  cursor: pointer;
  .text{
    color: rgba(186, 193, 204, 1);
    font-size: 14px;
    text-align: left;
    font-family: HarmonyOS_Sans_SC-regular;
    margin-left: 8px;
    margin-top: -1px;
  }
}
.user-box{
  margin-right: 24px;
  display: inline-block;
  cursor: pointer;
  .text{
    margin-right: 4px;
  }
}
/deep/ .el-dialog{
  z-index: 3000;
}
.ant-dropdown-menu{
    max-height: 400px;
    overflow-y: scroll;
}
.icon-left{
  color: rgba(186, 193, 204, 1);
  font-size: 20px;
  cursor: pointer;
}
.wang-zhan{
  line-height: 20px;
  border-radius: 8px;
  background-color: rgba(78, 86, 102, 1);
  display: flex;
  align-items: center;
  padding: 6px;
  cursor: pointer;
}
.icon-zhan{
    font-size: 20px;
    color: rgba(186, 193, 204, 1);
}
.text-zhan{
  color: rgba(186, 193, 204, 1);
  font-size: 14px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
  margin-left: 4px;
}
.down-icon{
  color: rgba(186, 193, 204, 1);
  font-size: 20px;
  margin-left: 5px;
}
.name-icon{
  color: rgba(186, 193, 204, 1);
  font-size: 20px;
}
/deep/ .el-dialog__title{
  font-weight: 600;
}
/deep/ .el-dialog__close{
  font-weight: 600;
}
.demo-ruleForm{
  .el-button--primary {
    background: #176de6;
  }
}
/deep/ .el-dialog__body{
  padding-top: 10px;
  padding-bottom: 0px;
}
/deep/ .el-button--primary {
  background: #176de6;
}
/deep/ .ri-eye-fill:before{
   color: #97A1AF;
}
.title-box {
  display: flex;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding: 8px 10px;
  color: rgba(144, 147, 153, 1);
  font-size: 13px;
  text-align: left;
  margin-bottom: 20px;
  font-family: HarmonyOS_Sans_SC-regular;
  .icon-title {
    color: #a9aab1;
    transform: rotate(-13deg);
    margin-top: 3px;
    margin-right: 2px;
  }
  /deep/ .anticon-close {
    color: rgba(48, 49, 51, 1);
    font-size: 20px;
    font-weight: bold;
  }
}

</style>